/*
 * tc-details-expanded.js: native disclosures (details/summary) tell screen readers
 * when they open and close (issue #613, WCAG 4.1.2).
 *
 * WHY: NVDA with Chrome does not hear a details element open or close, and keeps
 * reporting the old state. NVDA 2026.2 pass of 2026-10-14: Enter on "Return
 * policy" opened it on screen, NVDA said nothing, and NVDA+Tab still answered
 * "collapsed" (exports/live-theme-a11y/kids-pdp-nvda-2026-10-14.md). Chrome's own
 * accessibility tree had the right state; the change event never reached NVDA.
 * With aria-expanded on the summary, the same test announced "expanded" and
 * "collapsed" and re-read the right state every time.
 *
 * WHAT: mirrors each details element's open state onto its own summary as
 * aria-expanded ("true" or "false"):
 * - once when the document is ready;
 * - again for a theme editor section load;
 * - on every toggle event, which also follows scripts that set details.open.
 * toggle does not bubble, so the listener sits on document in the capture phase.
 * A details element added later (quickview, AJAX, the theme editor) gets the
 * attribute on its first toggle; until then it keeps the browser's own state.
 *
 * Additive only: no markup, style or behavior changes, and it never opens or
 * closes anything. It covers every native fold-out on the site; at the time of
 * writing those are sections/jojo-faq.liquid, jojo-pdp-details.liquid,
 * contact-faq.liquid, warranty-coverage.liquid, warranty-durations.liquid,
 * tc-accordion-band.liquid and snippets/share.liquid, plus fold-outs written into
 * store content, such as details.collection-details in a collection description
 * (toggled by the inline script in sections/collection.liquid).
 */
(function () {
  'use strict';

  function summaryOf(details) {
    for (var child = details.firstElementChild; child; child = child.nextElementSibling) {
      if (child.tagName === 'SUMMARY') return child;
    }
    return null;
  }

  function sync(details) {
    var summary = summaryOf(details);
    if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
  }

  function syncAll(root) {
    var list = (root || document).querySelectorAll('details');
    for (var i = 0; i < list.length; i++) sync(list[i]);
  }

  document.addEventListener('toggle', function (event) {
    var target = event.target;
    if (target && target.tagName === 'DETAILS') sync(target);
  }, true);

  document.addEventListener('shopify:section:load', function (event) {
    syncAll(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { syncAll(); });
  } else {
    syncAll();
  }
})();
